import { addTask } from "../utils/bugFixer";
import { Action, Reducer } from "redux";
import * as Api from "../api/api";
import { AppThunkAction } from ".";
import { getDefaultHeaders } from "../utils/utils";

export interface CarrierRatesOfferInformationState {
    isLoading: boolean;
    requestTime?: number;
    selectedId?: number;
    entities: Array<Api.CarrierRatesOfferInformationModel>;
    createState: {
        isLoading: boolean;
        requestTime?: number;
    };
    updateState: {
        [id: number]: {
            isLoading: boolean;
            requestTime?: number;
        }
    }
    deleteState: {
        [id: number]: {
            isLoading: boolean;
            requestTime?: number;
        }
    };
}

interface RequestCarrierRatesOfferInformationEntities {
    type: "REQUEST_CARRIERRATESOFFERINFORMATION_ENTITIES";
    payload: { requestTime: number };
}
interface ReceiveCarrierRatesOfferInformationEntities {
    type: "RECEIVE_CARRIERRATESOFFERINFORMATION_ENTITIES";
    payload: { requestTime: number; entities?: Array<Api.CarrierRatesOfferInformationModel> };
    error?: any;
}

interface RequestCarrierRatesOfferInformationCreate {
    type: "REQUEST_CARRIERRATESOFFERINFORMATION_CREATE";
    payload: { requestTime: number };
}
interface ReceiveCarrierRatesOfferInformationCreate {
    type: "RECEIVE_CARRIERRATESOFFERINFORMATION_CREATE";
    payload: { requestTime: number; entity?: Api.CarrierRatesOfferInformationModel };
    error?: any;
}

interface RequestCarrierRatesOfferInformationUpdate {
    type: "REQUEST_CARRIERRATESOFFERINFORMATION_UPDATE";
    payload: { requestTime: number; id: number; };
}
interface ReceiveCarrierRatesOfferInformationUpdate {
    type: "RECEIVE_CARRIERRATESOFFERINFORMATION_UPDATE";
    payload: { requestTime: number; id: number; entity?: Api.CarrierRatesOfferInformationModel };
    error?: any;
}

interface RequestCarrierRatesOfferInformationDelete {
    type: "REQUEST_CARRIERRATESOFFERINFORMATION_DELETE";
    payload: { requestTime: number; id: number; };
}
interface ReceiveCarrierRatesOfferInformationDelete {
    type: "RECEIVE_CARRIERRATESOFFERINFORMATION_DELETE";
    payload: { requestTime: number; id: number; };
    error?: any;
}

interface UpdateCarrierRatesOfferInformationSelectedId {
    type: "UPDATE_CARRIERRATESOFFERINFORMATION_SELECTEDID";
    payload: { value: number; };
}

export type KnownAction = RequestCarrierRatesOfferInformationEntities
    | ReceiveCarrierRatesOfferInformationEntities
    | RequestCarrierRatesOfferInformationCreate
    | ReceiveCarrierRatesOfferInformationCreate
    | RequestCarrierRatesOfferInformationUpdate
    | ReceiveCarrierRatesOfferInformationUpdate
    | RequestCarrierRatesOfferInformationDelete
    | ReceiveCarrierRatesOfferInformationDelete
    | UpdateCarrierRatesOfferInformationSelectedId
    ;

export const actionCreators = {
    requestCarrierRatesOfferInformation: (requestTime: number): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.CarrierRatesOfferInformationApi();
        let fetch = api.getEntities({ credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(entities => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESOFFERINFORMATION_ENTITIES",
                    payload: { requestTime: requestTime, entities: entities }
                });
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESOFFERINFORMATION_ENTITIES",
                    payload: { requestTime: requestTime, },
                    error: err
                });
            });

        dispatch({
            type: "REQUEST_CARRIERRATESOFFERINFORMATION_ENTITIES",
            payload: { requestTime: requestTime }
        });
        addTask(fetch);
        return fetch;
    },
    requestCreateCarrierRatesOfferInformation: (requestTime: number, model: Api.CarrierRatesOfferInformationModel): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.CarrierRatesOfferInformationApi();
        let fetch = api.create({ model: model }, { credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(entity => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESOFFERINFORMATION_CREATE",
                    payload: { requestTime: requestTime, entity: entity }
                });
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESOFFERINFORMATION_CREATE",
                    payload: { requestTime: requestTime, },
                    error: err
                });
            });

        dispatch({
            type: "REQUEST_CARRIERRATESOFFERINFORMATION_CREATE",
            payload: { requestTime: requestTime }
        });
        return fetch;
    },
    requestUpdateCarrierRatesOfferInformation: (requestTime: number, model: Api.CarrierRatesOfferInformationModel): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.CarrierRatesOfferInformationApi();
        let fetch = api.update({ model: model }, { credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(entity => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESOFFERINFORMATION_UPDATE",
                    payload: { requestTime: requestTime, id: model.carrierRatesOfferInformationId, entity: entity }
                });
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESOFFERINFORMATION_UPDATE",
                    payload: { requestTime: requestTime, id: model.carrierRatesOfferInformationId },
                    error: err
                });
            });

        dispatch({
            type: "REQUEST_CARRIERRATESOFFERINFORMATION_UPDATE",
            payload: { requestTime: requestTime, id: model.carrierRatesOfferInformationId }
        });
        return fetch;
    },
    requestDeleteCarrierRatesOfferInformation: (requestTime: number, id: number): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.CarrierRatesOfferInformationApi();
        let fetch = api._delete({ id: id }, { credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(entity => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESOFFERINFORMATION_DELETE",
                    payload: { requestTime: requestTime, id: id }
                });
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESOFFERINFORMATION_DELETE",
                    payload: { requestTime: requestTime, id: id },
                    error: err
                });
            });

        dispatch({
            type: "REQUEST_CARRIERRATESOFFERINFORMATION_DELETE",
            payload: { requestTime: requestTime, id: id }
        });
        return fetch;
    },
    updateCarrierRatesOfferInformationSelectedId: (id: number) => <UpdateCarrierRatesOfferInformationSelectedId>{
        type: "UPDATE_CARRIERRATESOFFERINFORMATION_SELECTEDID",
        payload: { value: id }
    }
};


const unloadedState: CarrierRatesOfferInformationState = {
    isLoading: false,
    createState: {
        isLoading: false
    },
    deleteState: {},
    updateState: {},
    entities: []
};


export const reducer: Reducer<CarrierRatesOfferInformationState> = (state: CarrierRatesOfferInformationState, incomingAction: Action) => {
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case "REQUEST_CARRIERRATESOFFERINFORMATION_ENTITIES":
            return {
                ...state,
                isLoading: true,
                requestTime: action.payload.requestTime
            };
        case "RECEIVE_CARRIERRATESOFFERINFORMATION_ENTITIES":
            if (state.requestTime !== action.payload.requestTime)
                return state;

            return {
                ...state,
                isLoading: false,
                entities: action.error
                    ? state.entities
                    : action.payload.entities
            };
        case "REQUEST_CARRIERRATESOFFERINFORMATION_CREATE":
            return {
                ...state,
                createState: {
                    ...state.createState,
                    isLoading: true,
                    requestTime: action.payload.requestTime
                }
            };
        case "RECEIVE_CARRIERRATESOFFERINFORMATION_CREATE":
            if (action.payload.requestTime !== state.createState.requestTime)
                return state;

            return {
                ...state,
                createState: {
                    ...state.createState,
                    isLoading: false,
                },
                entities: action.error
                    ? state.entities
                    : state.entities.concat([action.payload.entity])
            };
        case "REQUEST_CARRIERRATESOFFERINFORMATION_UPDATE":
            return {
                ...state,
                updateState: {
                    ...state.updateState,
                    [action.payload.id]: {
                        ...state.updateState[action.payload.id],
                        isLoading: true,
                        requestTime: action.payload.requestTime
                    }
                }
            };
        case "RECEIVE_CARRIERRATESOFFERINFORMATION_UPDATE":
            if (!state.updateState[action.payload.id]
                || action.payload.requestTime !== state.updateState[action.payload.id].requestTime)
                return state;

            return {
                ...state,
                updateState: {
                    ...state.updateState,
                    [action.payload.id]: {
                        ...state.updateState[action.payload.id],
                        isLoading: true,
                        requestTime: action.payload.requestTime
                    }
                },
                entities: action.error
                    ? state.entities
                    : state.entities.map(x => x.carrierRatesOfferInformationId === action.payload.entity.carrierRatesOfferInformationId
                        ? { ...x, ...action.payload.entity }
                        : x)
            };
        case "REQUEST_CARRIERRATESOFFERINFORMATION_DELETE":
            return {
                ...state,
                deleteState: {
                    ...state.deleteState,
                    [action.payload.id]: {
                        ...state.deleteState[action.payload.id],
                        isLoading: true,
                        requestTime: action.payload.requestTime
                    }
                }
            };
        case "RECEIVE_CARRIERRATESOFFERINFORMATION_DELETE":
            if (!state.deleteState[action.payload.id]
                || action.payload.requestTime !== state.deleteState[action.payload.id].requestTime)
                return state;

            return {
                ...state,
                deleteState: {
                    ...state.deleteState,
                    [action.payload.id]: {
                        ...state.deleteState[action.payload.id],
                        isLoading: true,
                        requestTime: action.payload.requestTime
                    }
                },
                selectedId: action.payload.id === state.selectedId
                    ? undefined
                    : state.selectedId,
                entities: action.error
                    ? state.entities
                    : state.entities.filter(x => x.carrierRatesOfferInformationId !== action.payload.id)
            };
        case "UPDATE_CARRIERRATESOFFERINFORMATION_SELECTEDID":
            return {
                ...state,
                selectedId: action.payload.value
            };
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            const exhaustiveCheck: never = action;
    }

    // For unrecognized actions (or in cases where actions have no effect), must return the existing state
    //  (or default initial state if none was supplied)
    return state || unloadedState;
};